<template>
  <VueDragResize
    :isActive="true"
    w="auto"
    h="auto"
    :y="colorBarDragY"
    :x="colorBarDragX"
    :isResizable="false"
    :isDraggable="colorBarDraggable"
    :parentLimitation="true"
  >
    <div style="margin-right: 20px">
      <div class="color-bar" :style="{ bottom: bottom }">
        <div class="color-bar-title" v-if="showTitle">
          {{ dataTypeInfo.label }}
        </div>
        <canvas
          :id="canvasId"
          :width="bar_length"
          :height="bar_height"
        ></canvas>
      </div>

      <!-- 色条数字 -->
      <div
        v-if="dataTypeInfo.default_bar_type !== 'stair'"
        class="color-bar-val"
        :style="{ width: bar_length + 'px' }"
      >
        <span
          style="
          color: white;
          position: absolute;
          top: 0;
          left: 4px;
          cursor: pointer;
        "
        >
          <!-- <a-popover title trigger="click" v-model="visibleMin">
          <template slot="content">
            <div style="height: 200px;width: 50px;">
              <a-slider
                vertical
                :min="1"
                :max="max"
                v-model="minSet"
                @change="onChangeMin"
                style="margin-bottom: 15px"
              />
              <a-input-number
                :min="1"
                :max="max"
                v-model="minSet"
                size="small"
                @change="onChangeMin"
                style="width: 50px;margin-top: 8px"
              />
            </div>
          </template>
          {{ min }}
        </a-popover> -->
        </span>
        <span
          style="
          color: white;
          position: absolute;
          top: 0;
          right: 4px;
          cursor: pointer;
        "
        >
          <!-- <a-popover title trigger="click" v-model="visibleMax">
          <template slot="content">
            <div style="height: 200px;width: 50px;">
              <a-slider
                vertical
                :min="min"
                :max="colorBarMax"
                v-model="maxSet"
                @change="onChangeMax"
              />
              <a-input-number
                :min="min"
                :max="colorBarMax"
                v-model="maxSet"
                size="small"
                @change="onChangeMax"
                style="width: 50px;margin-top: 8px"
              />
            </div>
          </template>
          {{ max }}
        </a-popover> -->
        </span>
      </div>
    </div>
  </VueDragResize>
</template>
<script>
import VueDragResize from "vue-drag-resize";
export default {
  props: {
    colorType: String,
    drawValue: String,
    colorRangeDefault: {
      type: Array,
      default: null
    },
    bottom: {
      type: String,
      default: "20px"
    },
    canvasId: {
      type: String,
      default: "myCanvas"
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    showTopNum: {
      type: Boolean,
      default: true
    },
    colorBarDraggable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      min: 0,
      max: 700,
      minSet: 0,
      maxSet: 0,
      visibleMin: false,
      visibleMax: false,
      colorBarMax: 1000,
      bar_length: 350,
      bar_height: 55,
      c: null,
      ctx: null,
      colorBarDragX: 0,
      colorBarDragY: 0
    };
  },
  components: {
    VueDragResize
  },
  computed: {
    colorBar() {
      return new colorIntensity.getColorBar({
        dataType: this.drawValue,
        colorType: this.colorType
      });
    },
    dataTypeInfo() {
      let config = G_SENSOR_DATA_TYPE_INFO.find(
        x => x.value === this.drawValue
      );
      return config;
    }
  },
  created() {
    const innerWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      innerHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

    this.colorBarDragX = innerWidth - 220 - 10 - 20;
    this.colorBarDragY = innerHeight - 64 - 10;
  },
  mounted() {
    this.initCanvas();
    this.getColors();
  },
  watch: {
    visibleMin() {
      if (this.visibleMin) {
        this.minSet = this.min;
      }
    },
    visibleMax() {
      if (this.visibleMax) {
        this.maxSet = this.max;
      }
    },
    drawValue() {
      this.getColors();
    },
    colorType() {
      this.getColors();
    },
    showTopNum() {
      this.getColors();
    }
  },
  methods: {
    // onChangeMin(val) {
    //   if (!val) val = 0;
    //   if (val < 0) val = 0;
    //   this.min = val;
    //   this.handleColorBarChange([this.min, this.max]);
    // },
    // onChangeMax(val) {
    //   if (!val && val != 0) return;
    //   val = val > this.colorBarMax ? this.colorBarMax : val;
    //   this.max = val;
    //   this.handleColorBarChange([this.min, this.max]);
    // },
    initCanvas() {
      // 真实渐变
      this.c = document.getElementById(this.canvasId);
      this.ctx = this.c.getContext("2d");
    },
    drawCanvas() {
      console.log("drawCanvas", this.dataTypeInfo);
      this.clearCanvas();
      if (this.dataTypeInfo.default_bar_type === "gradient") {
        this.draw1();
      } else {
        this.draw4();
      }
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);
    },
    getColors() {
      let color_range_max = this.dataTypeInfo.color_range_max;
      this.colorBarMax = color_range_max * 2;
      if (this.colorRangeDefault) {
        this.min = this.colorRangeDefault[0];
        this.max = this.colorRangeDefault[1];
      } else {
        this.min = this.dataTypeInfo.color_range_min;
        this.max = color_range_max;
      }

      this.handleColorBarChange([this.min, this.max]);
      this.drawCanvas();
    },
    // 真实渐变
    draw1() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var grd = this.ctx.createLinearGradient(0, 0, bar_length, 0);
      var lastRate = 0;
      var idx = 0;
      for (var b of bar_data) {
        grd.addColorStop(b.rate, b.bgcolor);
        let rate = b.max / bar_max;
        lastRate = rate;
        idx++;
      }
      this.ctx.fillStyle = grd;
      this.ctx.fillRect(0, 30, bar_length, 30);
    },

    // 真实阶梯
    draw2() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var lastRate = 0;
      for (var b of bar_data) {
        let rate = b.max / bar_max;
        this.ctx.fillStyle = b.bgcolor;
        this.ctx.fillRect(lastRate * bar_length, 30, rate * bar_length, 30);
        this.ctx.fillStyle = b.fgcolor;
        this.ctx.textAlign = "center";
        this.ctx.font = "13px Verdana";
        this.ctx.fillText(
          b.description,
          ((rate - lastRate) / 2 + lastRate) * bar_length,
          18
        );
        lastRate = rate;
      }
    },

    // 等比渐变
    draw3() {
      var bar_length = this.bar_length;
      var bar_data = this.colorBar.data;
      var bar_max = bar_data[bar_data.length - 1].max;
      var grd_eq = this.ctx.createLinearGradient(0, 0, bar_length, 0);
      var lastRate = 0;
      var idx = 0;
      for (var b of bar_data) {
        grd_eq.addColorStop(
          (1 / bar_data.length) * idx + 1 / (2 * bar_data.length),
          b.bgcolor
        );
        let rate = b.max / bar_max;
        lastRate = rate;
        idx++;
      }
      this.ctx.fillStyle = grd_eq;
      this.ctx.fillRect(0, 30, bar_length, 30);
    },
    // 等比阶梯
    draw4() {
      var bar_length = this.bar_length;
      var bar_data = this.$_.cloneDeep(this.colorBar.data);
      if (this.drawValue == "dissolved_oxygen") {
        bar_data = bar_data.reverse();
      }
      var idx = 0;
      let block_width = bar_length / bar_data.length;
      for (var b of bar_data) {
        this.ctx.fillStyle = b.bgcolor;
        this.ctx.fillRect(block_width * idx, 30, block_width, 30);
        this.ctx.textAlign = "center";

        if (this.colorBar.show_desc) {
          this.ctx.fillStyle = b.fgcolor;
          this.ctx.textAlign = "center";

          this.ctx.font = "13px Verdana";
          let x = block_width * (idx + 0.5);
          this.ctx.fillText(b.description, x, 20);
        }

        if (this.showTopNum) {
          if (this.colorBar.show_max_num) {
            this.ctx.fillStyle = "blue";
            this.ctx.font = "15px Verdana";
            if (idx < bar_data.length - 1) {
              this.ctx.fillText(b.max, block_width * (idx + 1), 20);
            }
          }
        }

        if (this.showTitle) {
          if (this.drawValue != "ph") {
            this.ctx.fillStyle = "#000";
            this.ctx.font = "14px Verdana";
            this.ctx.fillText(b.category, block_width * (idx + 0.5), 48);
          }
        }

        idx++;
      }
    },

    handleColorBarChange(v) {
      this.min = v[0];
      this.max = v[1];
      this.$store.commit("setColorRange", v);
    }
  }
};
</script>

<style scoped>
.color-bar {
  display: flex;
  position: absolute;
  bottom: 20px;
  z-index: 10;
  right: 20px;
  vertical-align: middle;
}
.color-bar-title {
  width: 48px;
  color: red;
  font-size: 16px;
  font-weight: 550;
  position: relative;
  left: 0px;
  text-align: right;
  margin: 30px 8px 0;
}

.color-bar-val {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: white;
  z-index: 10;
  height: 25px;
  line-height: 25px;
}
</style>
